import React, { useContext } from 'react'
import { Trans, t } from '@lingui/macro'
import IconPencil from '../../../components/common/icon/IconPencil'
import IconTrash from '../../../components/common/icon/IconTrash'
import IconScreenDesktop from '../../../components/common/icon/IconScreenDesktop'
import IconButton from '../../../components/common/form/button/IconButton'
import IconInfo from '../../../components/common/icon/IconInfo'
import Tooltip from '../../../components/common/tooltip/Tooltip'

import BorderedBox, {
  BorderedBoxStats
} from '../../../components/common/bordered-box/BorderedBox'
import { ManageCampaignContext } from '../ManageCampaignPage'
import { isCampaignImmediate } from '../utils'
import IconEye from '../../../components/common/icon/IconEye'
import { CampaignBannerModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'

import './CampaignAction.less'
import { ButtonIcon } from 'front-end/src/components'
import IconDuplicate from 'front-end/src/components/common/icon/IconDuplicate'

const CampaignBannerAction = ({
  banner,
  onEditClick,
  onDeleteClick,
  bannerHide,
  onCopyClick
}: {
  banner: CampaignBannerModelAsEditor
  onEditClick: (e: React.MouseEvent<any>) => void
  onDeleteClick: (e: React.MouseEvent<any>) => void
  onCopyClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  bannerHide: boolean
}) => {
  const CampaignActionControls = () => {
    const { campaign } = useContext(ManageCampaignContext)
    if (bannerHide) {
      return null
    }

    let editButton = (
      <IconButton icon={<IconPencil />} hint={t`Edit`} onClick={onEditClick} />
    )
    let showDeleteButton = true
    if (
      campaign.wasCampaignDeactivated ||
      (campaign.is_active && isCampaignImmediate(campaign))
    ) {
      editButton = (
        <IconButton
          icon={<IconEye />}
          hint={t`Details`}
          onClick={onEditClick}
        />
      )
      showDeleteButton = false
    }

    return (
      <div className="CampaignAction__controls">
        <div className="controls-inner">
          {editButton}
          <ButtonIcon
            circular
            icon={<IconDuplicate />}
            aria-label={t`Copy`}
            hint={t`Copy`}
            onClick={onCopyClick}
            className="IconButton"
          />
          {showDeleteButton ? (
            <IconButton
              icon={<IconTrash />}
              hint={t`Delete`}
              onClick={onDeleteClick}
            />
          ) : null}
        </div>
      </div>
    )
  }

  const hasData = !!(banner.uniqueViewCount || banner.uniqueClickCount)
  return (
    <BorderedBox className="CampaignAction">
      <div className="CampaignAction__icon">
        <IconScreenDesktop
          className={bannerHide ? 'lineAcross' : ''}
        ></IconScreenDesktop>
      </div>
      <div className="CampaignAction__desc">
        <b>
          {bannerHide ? <Trans>Hide banner</Trans> : <Trans>Show banner</Trans>}
          :&nbsp;
        </b>
        <i> {banner.header}</i>
      </div>
      <CampaignActionControls />
      {!bannerHide && (
        <BorderedBoxStats
          stats={[
            {
              className: 'views',
              caption: t`Views`,
              value: banner.uniqueViewCount || (hasData && '0') || '-'
            },
            {
              className: 'clicked',
              caption: t`Clicks`,
              value: banner.uniqueClickCount || (hasData && '0') || '-'
            },
            {
              className: 'effectiveness',
              caption: (
                <>
                  <Trans>Effectiveness</Trans> &nbsp;
                  <Tooltip
                    text={t`Effectiveness is ratio between unique view and unique clicks`}
                  >
                    <IconInfo />
                  </Tooltip>
                </>
              ),
              value:
                (banner.effectiveness && `${banner.effectiveness}%`) ||
                (hasData && '0%') ||
                '-'
            }
          ]}
        />
      )}
    </BorderedBox>
  )
}

export default CampaignBannerAction
